module.exports = __webpack_public_path__ + "img/notification.8851d946.svg";